import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/exhibition/companies')({
  staticData: { crumb: { parents: [{ label: 'Exhibition' }], label: 'Companies' } },
})
